import React, { memo } from 'react';
import PropTypes from 'prop-types';

const ArtistsListingCards = ({ artists, openPopup, type }) => {
  return (
    <>
      {artists &&
        artists.length &&
        artists.map((artist, i) => (
          <div
            key={artist.id}
            className='artist'
            onClick={() => openPopup(artist)}
          >
            <div
              className='artist__img'
              style={{
                backgroundImage: `url(${artist.photo})`,
              }}
            />
            <div className='buttonDiv'>
              <button className='artist__popup__btn'>
                About{' '}
                {type === 'conductors'
                  ? 'Conductor'
                  : type === 'orchestras'
                  ? 'Orchestra'
                  : 'Artist'}
              </button>
            </div>
            <div className='artist__text'>
              <h3
                className='artist__name'
                dangerouslySetInnerHTML={{
                  __html:
                    type === 'orchestras'
                      ? artist.name
                      : `${artist.name} ${artist.surname}`,
                }}
              />
              <p className='artist__details'>
                {artist.instrument && <span className='artist__instrument'>{artist.instrument}</span>}
                <span className='artist__location'>({artist.country.replace('/', ' / ')})</span>
              </p>
            </div>
          </div>
        ))}
    </>
  );
};

ArtistsListingCards.propTypes = {
  artists: PropTypes.array.isRequired,
  openPopup: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
};

export default memo(ArtistsListingCards);
